import React from 'react';
import SahabaVillas from './SahabaVillas';
import { villaData } from '../data/data';
import { Helmet } from 'react-helmet';

export default function SahabaVillasPage() {
  // Find the Sahaba Villas specific data inside the villaData array
  const sahabaData = villaData.find(v => v.slug === "sahabavillas");

  if (!sahabaData) {
    return <div className="text-center py-20 text-2xl">Property Not Found</div>;
  }

  return (
    <div data-aos="zoom-in">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Sahaba Villas | Al Ghaith Properties</title>
        <meta name="description" content="Discover Sahaba Villas by Al Ghaith Properties — where exceptional living comes together through luxury, serenity, spaciousness and privacy." />
        <link rel="canonical" href={`https://www.al-ghaith.ae/#/projects/villa/sahabavillas`} />
      </Helmet>
      <SahabaVillas data={sahabaData} />
    </div>
  );
}
